import Rule from "../../../common/rule";
import FootballState from "../../state/football-state";

export default class SwapTeams extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return fragment.associatedState === FootballState.SwapTeams;
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { swapTeams } = fragment;

        gameContext.swapTeams = swapTeams;
    }
}
